import React from "react";

/**
 * SelectRemoveIcon component returns an SVG icon for use in the UI.
 *
 * @return {JSX.Element} SVG icon
 */
export const SelectRemoveIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2426 1.75734C9.10938 0.624117 7.60266 0 6 0C4.39734 0 2.89062 0.624117 1.75737 1.75734C0.624117 2.89062 0 4.39734 0 6C0 7.60266 0.624117 9.10938 1.75737 10.2427C2.89062 11.3759 4.39734 12 6 12C7.2097 12 8.37577 11.6415 9.37214 10.9634C9.58615 10.8177 9.64155 10.5261 9.49589 10.3121C9.35023 10.0981 9.05864 10.0427 8.84463 10.1884C8.00442 10.7602 7.02077 11.0625 6 11.0625C3.20852 11.0625 0.9375 8.79148 0.9375 6C0.9375 3.20852 3.20852 0.9375 6 0.9375C8.79148 0.9375 11.0625 3.20852 11.0625 6C11.0625 6.93187 10.8073 7.84247 10.3246 8.63337C10.1897 8.85436 10.2596 9.1428 10.4805 9.27769C10.7015 9.41262 10.99 9.34273 11.1248 9.1218C11.6974 8.18374 12 7.10423 12 6C12 4.39734 11.3759 2.89062 10.2426 1.75734Z"
        fill="#ED3A3E"
      />
      <path
        d="M7.86722 4.13277C7.69019 3.95574 7.40319 3.95574 7.22618 4.13277L6.00001 5.35895L4.77384 4.13277C4.59681 3.95574 4.30981 3.95574 4.1328 4.13277C3.95579 4.30981 3.95576 4.59683 4.1328 4.77384L5.35895 6.00001L4.13277 7.22619C3.95574 7.40322 3.95574 7.69024 4.13277 7.86725C4.22128 7.95576 4.33728 8 4.4533 8C4.56931 8 4.68531 7.95576 4.77382 7.86725L6.00001 6.64108L7.22618 7.86725C7.31469 7.95576 7.43068 8 7.5467 8C7.66272 8 7.77872 7.95576 7.86722 7.86725C8.04426 7.69022 8.04426 7.4032 7.86722 7.22619L6.64107 6.00001L7.86725 4.77384C8.04425 4.59683 8.04426 4.30981 7.86722 4.13277Z"
        fill="#ED3A3E"
      />
    </svg>
  );
};
